import React from 'react'

import { AlignItems, Box, Color, FlexDirection, Text } from '@gousto-internal/citrus-react'

export const DividerWithText = ({ text }: { text: string }) => (
  <Box
    display="flex"
    flexDirection={FlexDirection.Row}
    width="100%"
    alignItems={AlignItems.Center}
    gap={2}
  >
    <Box height="0.0625rem" bg={Color.ColdGrey_200} flexGrow={1} />
    <Text size={2} color={Color.ColdGrey_800}>
      {text}
    </Text>
    <Box height="0.0625rem" bg={Color.ColdGrey_200} flexGrow={1} />
  </Box>
)
